// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-date-picker-months {
  height: 288px;
}

:where(.vuetify-styles) .v-date-picker-months__content {
  align-items: center;
  display: grid;
  flex: 1 1;
  height: inherit;
  justify-content: space-around;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0px 24px;
  padding-inline-start: 36px;
  padding-inline-end: 36px;
}
:where(.vuetify-styles) .v-date-picker-months__content .v-btn {
  text-transform: none;
  padding-inline-start: 8px;
  padding-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDatePicker/VDatePickerMonths.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".v-date-picker-months {\n  height: 288px;\n}\n\n.v-date-picker-months__content {\n  align-items: center;\n  display: grid;\n  flex: 1 1;\n  height: inherit;\n  justify-content: space-around;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 0px 24px;\n  padding-inline-start: 36px;\n  padding-inline-end: 36px;\n}\n.v-date-picker-months__content .v-btn {\n  text-transform: none;\n  padding-inline-start: 8px;\n  padding-inline-end: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
